import { render } from "./Billing.vue?vue&type=template&id=dad01622"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"
script.render = render

export default script